<template>
  <div style="position: relative">
    <mx-preloader style="top: -7px; background-color: #ffffff; padding-top: 60px" :loader-status="preloader" :logo="false"/>
    <v-autocomplete
        v-model="result"
        :disabled="isUpdating"
        :items="roles"
        outlined
        chips
        color="blue-grey lighten-2"
        :label="$t('document.role.select')"
        item-text="name"
        item-value="id"
        multiple
        hide-details
    >

      <template v-slot:selection="data">
        <v-chip style="height: 48px; padding: 0 18px 0 14px;" label v-bind="data.attrs" :input-value="data.selected" close @click="data.select" @click:close="remove(data.item)">
          <div style="display: flex; flex-direction: column; margin: 0 10px 0 0;">
            <strong>{{ data.item.display_name }}</strong>
          </div>
        </v-chip>
      </template>
      <template v-slot:item="data">
        <template v-if="typeof data.item !== 'object'">
          <v-list-item-content v-text="data.item"></v-list-item-content>
        </template>
        <template v-else>
          <v-list-item-content>
            <v-list-item-title>
              {{ data.item.display_name }}
            </v-list-item-title>
          </v-list-item-content>
        </template>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
export default {
  name: 'MultiSelectRole',
  props: {
    selected: {
      type: Array,
      default: function () {
        return []
      },
    }
  },
  data() {
    return {
      preloader: true,
      autoUpdate: true,
      result: [],
      isUpdating: false,
      name: 'Midnight Crew',
      roles: [],
    }
  },
  watch: {
    isUpdating (val) {
      if (val) {
        setTimeout(() => (this.isUpdating = false), 3000)
      }
    },
    result() {
     this.resultSelect()
    },
  },
  created() {
    this.result = this.selected

    this.$store.dispatch('rolesEmployeeLaratrust', this.page).then(() => {
      this.roles = this.$store.getters.roles_employee_laratrust.data

      setTimeout(() => {
        this.preloader = false
      },300)

      this.resultSelect()
    })
  },
  methods: {
    remove (item) {
      const index = this.result.indexOf(item.id)
      if (index >= 0) this.result.splice(index, 1)
    },
    resultSelect() {
      this.$emit('result', this.result)
    }
  },
}
</script>
